"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SearchCondition = _interopRequireDefault(require("01_core/components/layout/SearchCondition"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CSelect = _interopRequireDefault(require("01_core/components/materials/CSelect"));
var _SelectKaishaSoshiki = _interopRequireDefault(require("01_core/components/select/SelectKaishaSoshiki"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _windowUtil = _interopRequireDefault(require("01_core/logics/windowUtil"));
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _bcmKunrenActions = require("../../bcmKunrenActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * ドキュメント管理（訓練）：検索条件表示部分
 */
class KunrenDocMngCondition extends _react.default.Component {
  constructor(props) {
    super(props);
    // 検索ボタン押下時のハンドラ
    _defineProperty(this, "onSearchClick", () => {
      const {
        intl,
        callAPI,
        setSearchResult,
        searchConditions,
        resetPaging,
        openInfoBar,
        doSearch,
        copySearchConditon,
        isNewWindow
      } = this.props;
      if (!doSearch) {
        resetPaging();
      }
      copySearchConditon(searchConditions);
      const form = {
        targetCd: searchConditions.targetCd,
        bcmKaishaSoshikiCd: searchConditions.bcmKaishaSoshikiCd
      };
      callAPI(_APIs.BCM_KUNREN_DOCMNG_SEARCH, form).then(response => {
        setSearchResult(response.data);
        if (!response.data) {
          // 検索時に結果が null(= 0件) の場合は一致なしのメッセージを表示する。
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.INFO, intl.formatMessage({
            id: _labelConsts.LABEL.CORE_NO_SEARCH_RESULT_MESSAGE
          }));
        } else {
          // 検索結果が存在した場合、検索結果一覧にスクロールする。
          if (!doSearch) {
            _windowUtil.default.scrollBelowElement(this.area.current, isNewWindow);
          }
        }
      });
    });
    // 検索条件変更時のハンドラ
    _defineProperty(this, "handleSearchConditionChange", key => {
      return value => {
        this.props.changeSearchCondition(key, value);
      };
    });
    this.area = /*#__PURE__*/_react.default.createRef();
    props.callAPI(_APIs.BCM_KUNREN_DOCMNG_SEARCH_KUNREN).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        if (!props.init) {
          props.changeSearchCondition('targetCd', response.data[0].targetCd);
        }
        let targetList = [];
        response.data.forEach(target => {
          targetList.push({
            value: target.targetCd,
            displayName: target.exercisesNm
          });
        });
        props.changeSearchCondition('targetList', targetList);
      }
    });
  }
  componentDidMount() {
    if (this.props.doSearch) {
      this.onSearchClick();
    }
  }
  render() {
    const {
      intl,
      searchConditions,
      changeSearchCondition
    } = this.props;
    const conditions = [/*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_TRAINING_NAME
      })
    }, /*#__PURE__*/_react.default.createElement(_CSelect.default, {
      value: searchConditions.targetCd,
      onChange: this.handleSearchConditionChange('targetCd'),
      items: searchConditions.targetList
    })), /*#__PURE__*/_react.default.createElement(_SelectKaishaSoshiki.default, {
      displayLabel: true,
      kaishaCd: searchConditions.kaishaCd,
      soshikiCd: searchConditions.soshikiCd,
      label: searchConditions.kaishasoshikiLabel ? searchConditions.kaishasoshikiLabel : '',
      bcmKaishaSoshikiCd: searchConditions.bcmKaishaSoshikiCd,
      bcmSelect: true,
      onChange: _ref => {
        let {
          kaishaCd,
          soshikiCd,
          label,
          bcmKaishaSoshikiCd
        } = _ref;
        changeSearchCondition('kaishaCd', kaishaCd);
        changeSearchCondition('soshikiCd', soshikiCd);
        changeSearchCondition('kaishasoshikiLabel', label);
        changeSearchCondition('bcmKaishaSoshikiCd', bcmKaishaSoshikiCd);
      }
    })];
    const closeBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
      onClick: () => {
        window.close();
      },
      negative: true
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CLOSE
    }));
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: this.area
    }, /*#__PURE__*/_react.default.createElement(_SearchCondition.default, {
      conditions: conditions,
      cancelBtn: closeBtn,
      onSearchClick: this.onSearchClick
    }));
  }
}
const mapStateToProps = state => {
  return {
    searchConditions: state.bcmKunren.searchConditions,
    doSearch: state.bcmKunren.doSearch,
    init: state.bcmKunren.init
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeSearchCondition: (key, value) => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.CHANGE_SEARCH_CONDITION](key, value)),
    copySearchConditon: searchConditions => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.COPY_SEARCH_CONDITION](searchConditions)),
    setSearchResult: resultList => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.SET_SEARCH_RESULT](resultList)),
    resetPaging: () => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.RESET_PAGING]()),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(KunrenDocMngCondition)));